import { validate, createValidationSchema, validateIfFile } from "@";

export const schema = createValidationSchema({
  MinAmountForDonations: validate("number", "MinAmountForDonations"),
  MinAmountForFastDonation: validate("number", "MinAmountForFastDonation"),
});

export const defaultValues = {
  WebsiteLogoUrl: "",
  WebsiteMainBanner: "",
  MotivationalSentence: "",
  MinAmountForDonations: 0,
  EnableFastDonation: false,
  EnableWhatsAppChat: false,
  CompleteProjectLogoUrl: "",
  ShowApplePayMessage: false,
  MinAmountForFastDonation: 0,
  NameMandatoryWhileLogin: false,
  HideBankAccountFromDonation: false,
  SmsVerificationWhenLogin: false,
};
